import React from 'react';
import Hero from '../components/Hero/Hero';
import Festivals from '../components/Festivals/Festivals';
import ScrollingBanner from '../components/ScrollingBanner/ScrollingBanner';
import CallToAction from '../components/CallToAction/CallToAction';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <Festivals />
      <ScrollingBanner />
      <CallToAction />
    </div>
  );
};

export default Home; 